import JSZip from 'jszip'

const GEOJSON_FILE_PATTERN = /\.(geojson|json)$/i

function base64ToBytes(base64Content) {
  const binary = atob(base64Content)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }
  return bytes
}

function isZipArchive(bytes) {
  return bytes.length >= 4 && bytes[0] === 0x50 && bytes[1] === 0x4b
}

function parseGeoJsonText(text) {
  const parsed = JSON.parse(text)
  if (!parsed || typeof parsed !== 'object') return null
  if (Array.isArray(parsed.features)) return parsed
  if (parsed.type === 'Feature') {
    return { type: 'FeatureCollection', features: [parsed] }
  }
  return null
}

async function decodeZipGeoJson(bytes) {
  const zip = await JSZip.loadAsync(bytes)
  const geoJsonEntry = Object.values(zip.files).find(
    (entry) => !entry.dir && GEOJSON_FILE_PATTERN.test(entry.name),
  )
  if (!geoJsonEntry) return null
  const text = await geoJsonEntry.async('string')
  return parseGeoJsonText(text)
}

export async function decodeMapLayerFileContent(base64Content) {
  if (!base64Content) return null

  try {
    const bytes = base64ToBytes(base64Content)
    if (isZipArchive(bytes)) {
      return await decodeZipGeoJson(bytes)
    }
    const text = atob(base64Content)
    return parseGeoJsonText(text)
  } catch {
    return null
  }
}
